var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"20px"},attrs:{"id":"student_sche"}},[_c('div',{staticClass:"contents"},[_c('v-weburl-iframe',{attrs:{"url":`teacher/table?student_id=${_vm.base.id}&hide_week=1`}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }